var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-background-color-control"
  }, [_c('div', {
    ref: "colorContainer",
    staticClass: "ugc-background-color-control-input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.colorValue,
      expression: "colorValue"
    }],
    ref: "selector_color_input",
    staticClass: "jscolor ugc-background-color-control-input",
    attrs: {
      "value": "#fff"
    },
    domProps: {
      "value": _vm.colorValue
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.colorValue = $event.target.value;
      }
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }